import { Button } from "../../../../../components/ui/button";
import { type TrailConclusionDisplay } from "../../lib/trailConclusion";

interface TrailConclusionBodyProps {
  conclusion: TrailConclusionDisplay;
  /** Opens the conclusion editor. When absent, an empty conclusion renders as
   * static placeholder text instead of a clickable prompt. */
  onAddConclusion?: () => void;
}

/**
 * The body of the Workpaper Review "Conclusion" block. An inconclusive result
 * shows a fixed message; a conclusive one shows its L1, or a prompt to write
 * one when the L1 is blank.
 */
export function TrailConclusionBody({
  conclusion,
  onAddConclusion,
}: TrailConclusionBodyProps) {
  if (conclusion.kind === "inconclusive") {
    return (
      <div className="whitespace-pre-wrap text-sm">{conclusion.message}</div>
    );
  }

  if (conclusion.kind === "empty") {
    if (!onAddConclusion) {
      return (
        <div className="text-sm italic text-stone-400">No conclusion yet.</div>
      );
    }
    return (
      <Button
        type="button"
        variant="link"
        onClick={onAddConclusion}
        className="h-auto justify-start p-0 text-sm font-normal italic text-stone-400 hover:text-stone-600 hover:no-underline"
      >
        Add a conclusion
      </Button>
    );
  }

  return <div className="whitespace-pre-wrap text-sm">{conclusion.text}</div>;
}
